export default __webpack_public_path__ + "static/media/public_bus.4f0a0c79.png";